import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import axios from '../../api/axios';

const BulkUploadModal = ({ onClose }) => {
    const [csvFile, setCsvFile] = useState(null);
    const [preview, setPreview] = useState([]);
    const [error, setError] = useState('');
    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);

    useEffect(() => {
        axios.get('/meta/categories').then(res => setCategories(res.data));
        axios.get('/meta/brands').then(res => setBrands(res.data));
    }, []);

    const handleCSV = (e) => {
        setCsvFile(e.target.files[0]);
        Papa.parse(e.target.files[0], {
            header: true,
            complete: (results) => {
                setPreview(results.data);
            },
            error: (err) => {
                setError("Failed to parse CSV");
                console.error(err);
            },
        });
    };

    const handleUpload = () => {
        axios.post('/items/bulk-upload', { items: preview })
            .then(() => {
                alert("Items uploaded successfully");
                onClose();
            })
            .catch((err) => {
                alert("Upload failed");
                console.error(err);
            });
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
                <h2 className="text-lg font-semibold mb-4">Upload CSV</h2>
                <input type="file" accept=".csv" onChange={handleCSV} className="mb-4" />
                <a
                    href="/templates/items-bulk-template"
                    download
                    className="text-blue-600 underline text-sm mb-3 inline-block"
                >
                    📥 Download Latest CSV Template
                </a>
                {error && <p className="text-red-500">{error}</p>}

                {preview.length > 0 && (
                    <div className="overflow-x-auto text-sm max-h-64 overflow-y-auto mb-4">
                        <table className="table-auto w-full border">
                            <thead>
                                <tr>
                                    {Object.keys(preview[0]).map(key => (
                                        <th key={key} className="border px-2 py-1 bg-gray-200">{key}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {preview.slice(0, 5).map((row, idx) => (
                                    <tr key={idx}>
                                        {Object.values(row).map((val, i) => (
                                            <td key={i} className="border px-2 py-1">{val}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <div className="flex justify-end gap-4">
                    <button className="bg-gray-500 text-white px-4 py-2 rounded" onClick={onClose}>Cancel</button>
                    <button className="bg-green-600 text-white px-4 py-2 rounded" onClick={handleUpload}>Upload</button>
                </div>
            </div>
        </div>
    );
};

export default BulkUploadModal;